import React from "react";
import { ReactComponent as BrainIcon } from './ai-chat/brain.svg';
import { ReactComponent as SpeedIcon } from './ai-chat/speed.svg';
import { ReactComponent as SettingsIcon } from './ai-chat/settings.svg';
import { ReactComponent as LoaderSpinner} from './ai-chat/loader.svg'
import { ReactComponent as ChatIcon} from './ai-chat/chat-icon.svg'
import { ReactComponent as ChatClearIcon} from './ai-chat/clearChat.svg'

const iconMap = {
  'chat-brain': BrainIcon,
  'chat-speed': SpeedIcon,
  'chat-settings': SettingsIcon,
  'chat-loader': LoaderSpinner,
  'chat-icon': ChatIcon,
  'chat-clear': ChatClearIcon,
  // Add more icons here
};

const SvgIcon = ({ id, ...props }) => {
  const IconComponent = iconMap[id];
  return IconComponent ? <IconComponent {...props} /> : null;
};

export default SvgIcon;
